import { useState } from "react";
import axios from "axios";
import { getSubThemesURL } from "../utils/ConstantsURL";

export function useGetSubThemes(token) {
  const [subThemes, setSubThemes] = useState([]);
  const [loadingSubThemes, setLoadingSubThemes] = useState(false);
  const [errorSubThemes, setErrorSubThemes] = useState(null);

  const fetchSubThemes = async (temaId) => {
    setLoadingSubThemes(true);
    setErrorSubThemes(null);
    try {
      const response = await axios.get(getSubThemesURL(temaId), {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSubThemes(response.data.data || []);
    } catch (error) {
      setErrorSubThemes(error.message || "Error buscando subtemas");
      setSubThemes([]);
    } finally {
      setLoadingSubThemes(false);
    }
  };

  return { subThemes, loadingSubThemes, errorSubThemes, fetchSubThemes };
}
